import React from "react";
import logo from "../images/logo.png";
import avatar from "../images/avatar.png";
export default function Reviews() {
  const reviews = [1, 2, 3, 4];
  return (
    <div className="bg-white flex items-center justify-center  font-poppins ">

      <div className="w-full  relative">

        

        <h2 className="text-base font-semibold text-black mb-4">
          See Reviews From Our Patients
        </h2>

        <div className="space-y-3">
          
          {reviews.map((item, idx) => (
            <div
              key={idx}
              className="border border-gray-200 rounded bg-white px-4 py-3 flex flex-col"
            >

              <div className="flex items-start justify-between mb-2">
                <div className="flex items-center gap-3">
                  <img
                    src={avatar}
                    alt="Patient"
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-[14px] font-semibold text-black">Arlene</p>
                    <p className="text-[11px] text-black">Aug 10, 2025</p>
                  </div>
                </div>

                <div className="flex items-center gap-[2px] text-yellow-400 text-sm">
                  <span>★</span>
                  <span>★</span>
                  <span>★</span>
                  <span>★</span>
                  <span>★</span>
                </div>
              </div>

              <p className="text-[12px] leading-relaxed text-black">
                I’d been having a hard time shifting the excess weight I’d piled
                on over recent years when a friend recommended the clinic to
                me/I’ve been with the clinic for several months now and my
                monthly interactions with Dr. Aasim have been nothing short of
                pleasant.{" "}
                <button className="text-[#56C7D5] font-medium">
                  See More
                </button>
              </p>
            </div>
          ))}
        </div>

        <button
          type="button"
          className="mt-5 w-[40%] border border-[#35C3D9] text-[#35C3D9] rounded-md py-3 text-sm font-medium bg-white hover:bg-[#E6F7FA] transition"
        >
          See more
        </button>
      </div>
    </div>
  );
};
